import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, TruckIcon, SmileIcon } from 'lucide-react';
export function ReservationSection() {
  const steps = [{
    number: '01',
    title: 'Contact Us',
    description: 'Call us toll-free at (800) 395-4459 or reserve online through our reservation page.',
    icon: PhoneIcon
  }, {
    number: '02',
    title: 'We Deliver',
    description: 'We deliver your chosen mobility equipment to your desired location at no extra cost.',
    icon: TruckIcon
  }, {
    number: '03',
    title: 'Enjoy Freedom',
    description: "Explore DC with confidence. Free pickup when you're done with your rental!",
    icon: SmileIcon
  }];
  return <section id="reserve" className="py-24 bg-brand-gray relative overflow-hidden" data-id="element-417">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-418">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-blue/5 rounded-full blur-3xl" data-id="element-419"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-red/5 rounded-full blur-3xl" data-id="element-420"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-421">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-422">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-navy mb-6" data-id="element-423">
            How to Reserve
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-charcoal/70" data-id="element-424">
            Getting your mobility equipment is simple, fast, and hassle-free.
            Follow these three easy steps to regain your freedom to explore.
          </motion.p>
        </div>

        <div className="relative" data-id="element-425">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden md:block absolute top-1/2 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-brand-blue/20 via-brand-red/30 to-brand-blue/20 -translate-y-1/2 z-0" data-id="element-426"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-427">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2,
            duration: 0.6
          }} className="flex flex-col items-center text-center group" data-id="element-428">
                <div className="relative mb-8" data-id="element-429">
                  <div className="w-24 h-24 bg-white rounded-full shadow-xl flex items-center justify-center border-4 border-brand-gray group-hover:border-brand-red transition-colors duration-300 relative z-10" data-id="element-430">
                    <step.icon className="w-10 h-10 text-brand-navy group-hover:text-brand-red transition-colors duration-300" data-id="element-431" />
                  </div>
                  <div className="absolute -top-3 -right-3 w-10 h-10 bg-brand-blue text-white rounded-full flex items-center justify-center font-bold text-sm shadow-md z-20" data-id="element-432">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-433">
                  {step.title}
                </h3>
                <p className="text-brand-charcoal/70 leading-relaxed" data-id="element-434">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-20 text-center flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-435">
          <a href="tel:+18003954459" className="w-full sm:w-auto px-8 py-4 bg-brand-red text-white rounded-full font-bold text-lg hover:bg-red-700 transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-436">
            <PhoneIcon className="w-5 h-5" data-id="element-437" />
            Call (800) 395-4459
          </a>
          <span className="text-brand-charcoal/50 font-medium" data-id="element-438">or</span>
          <a href="tel:+12023679965" className="w-full sm:w-auto px-8 py-4 bg-white text-brand-navy border border-gray-200 rounded-full font-bold text-lg hover:bg-gray-50 transition-all shadow-sm flex items-center justify-center gap-2" data-id="element-439">
            <PhoneIcon className="w-5 h-5" data-id="element-440" />
            Call (202) 367-9965
          </a>
        </motion.div>
      </div>
    </section>;
}